import React from "react";
import { Label } from "../ChartStudioFieldChip/ChartStudioFieldChip.styles";
import { IconSlot, Tag } from "./TagChip.styles";
import type { TagChipProps } from "./TagChip.types";

/** Read-only label pill — e.g. the type and role tags on the field hover card, or a row's source. */
export const TagChip: React.FC<TagChipProps> = ({ label, icon, tone = "neutral", size = "default", testId, as, showTitle = true, className }) => (
  <Tag as={as} className={className} data-testid={testId} data-tone={tone} $tone={tone} $size={size} $fullWidth={false} $layout="default" $surface="tinted">
    {icon ? <IconSlot aria-hidden="true">{icon}</IconSlot> : null}
    <Label title={showTitle ? label : undefined}>{label}</Label>
  </Tag>
);

export default TagChip;
